import { useState } from 'react';

import saveAs from 'file-saver';

import type { DateRange, UUID, Vehicle, VehicleGroup } from '@cobliteam/common-types';

import { type Driver, GraphQLUserAlertRequester, type UserAlert, type UserAlertsFilters } from '@cobliteam/api-lib';

import { format } from '@cobliteam/utils/date';

import { useUser } from '@cobliteam/hooks';

import UserAlertsSpreadsheet from '../../utils/UserAlertsSpreadsheet';

const excelWriter: UserAlertsSpreadsheet = new UserAlertsSpreadsheet();
const graphQLUserAlertRequester: GraphQLUserAlertRequester = new GraphQLUserAlertRequester();

const useReportExporter = () => {
  const [isLoadingReport, setIsLoadingReport] = useState<boolean>(false);
  const session = useUser().getSession();

  const downloadReportFile = (blob: Blob, name: string, startInMillis: number, endInMillis: number): void => {
    const startTimeStr = format(startInMillis, 'yyMMdd');
    const endTimeStr = format(endInMillis, 'yyMMdd');
    const periodStr = startTimeStr === endTimeStr ? startTimeStr : `${startTimeStr}_${endTimeStr}`;

    const filename = `Cobli_${periodStr}_historico_alertas.xlsx`;
    saveAs(blob, filename);
  };

  const generateReport = async (
    period: DateRange,
    driversById: Map<UUID, Driver>,
    vehiclesById: Map<UUID, Vehicle>,
    vehicleGroupsById: Map<UUID, VehicleGroup>,
    filters?: UserAlertsFilters
  ) => {
    setIsLoadingReport(true);
    const alertsPromise: UserAlert[] = await graphQLUserAlertRequester.getUnpagedAlerts(period, filters);
    const reportBlob: Blob = await excelWriter.buildExcel(alertsPromise, period, driversById, vehiclesById, vehicleGroupsById, session);
    downloadReportFile(reportBlob, 'historico_alertas', period.start, period.end);
    setIsLoadingReport(false);
  };

  return {
    generateReport,
    isLoadingReport,
  };
};

export default useReportExporter;
